import React from 'react';

import classNames from 'classnames/bind';
import style from './Scalable.scss';
const ctx = classNames.bind(style);

const Scalable = props => (
  <div className={ctx('scalable')} style={props.style}>
    <div className={ctx('scalable-inner')}>{props.children}</div>
  </div>
);

export default Scalable;
